/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  CreateCarricomAppService,
  ICreateCarricomAppMethods,
  CreateNewApplicationService,
  ICreateNewApplicationMethods,
  CreateWorkPermitDraftService,
  ICreateWorkPermitDraftMethods,
  IFormatAppDraftMethods,
  FormatAppDraftService,
  IInviteUserMethods,
  InviteUserService,
  GetCitiesService,
  IGetCitiesMethods,
  SaveApplicantApplicationService,
  ISaveApplicantApplicationMethods,
  GetOccupationListService,
  IGetOccupationListMethods,
  CanCreateNewAppService,
  ICanCreateNewAppMethods,
  resubmitAppService,
  IresubmitAppMethods,
  IGetMinimumWageMethods,
  GetMinimumWageService,
  resubmitApplicantService,
  IresubmitApplicantMethods,
  createroeworkPermitDraftService,
  IcreateroeworkPermitDraftMethods,
  createroerenewworkPermitDraftService,
  IcreateroerenewworkPermitDraftMethods,
  IGetTypeOfApplicationMethods,
  GetTypeOfApplicationService,
  IGetParishAndCityMethods,
  GetParishAndCityService,
  FetchDocumentsService,
  IFetchDocumentsMethods
} from './plugins';

export type ApplicationFormPageAgent = IStaticPageContentMethods &
  ICreateCarricomAppMethods &
  ICreateNewApplicationMethods &
  ICreateWorkPermitDraftMethods &
  IFormatAppDraftMethods &
  IInviteUserMethods &
  IGetCitiesMethods &
  ICanCreateNewAppMethods &
  ISaveApplicantApplicationMethods &
  IGetOccupationListMethods &
  IresubmitAppMethods &
  IGetMinimumWageMethods &
  IresubmitApplicantMethods &
  IcreateroeworkPermitDraftMethods &
  IcreateroerenewworkPermitDraftMethods &
  IcreateroeworkPermitDraftMethods &
  IGetTypeOfApplicationMethods & 
  IGetParishAndCityMethods &
  IFetchDocumentsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new CreateCarricomAppService(),
    new CreateNewApplicationService(),
    new CreateWorkPermitDraftService(),
    new FormatAppDraftService(),
    new InviteUserService(),
    new GetCitiesService(),
    new SaveApplicantApplicationService(),
    new GetOccupationListService(),
    new CanCreateNewAppService(),
    new resubmitAppService(),
    new GetMinimumWageService(),
    new resubmitApplicantService(),
    new createroeworkPermitDraftService(),
    new createroerenewworkPermitDraftService(),
    new GetTypeOfApplicationService(),
    new GetParishAndCityService(),
    new FetchDocumentsService(),
  ];
};

export const getAgent = () => {
  return createAgent<ApplicationFormPageAgent>({
    plugins: getPlugins(),
  });
};
